import { Icons } from '@/assets';
import { addAvatar, SaveData } from '@/actions';
import IconButton from '@/ctComponents/IconButton';
import Modal from '@/ctComponents/Modal';
import React, { useState, useRef } from 'react';
import { ReactSVG } from 'react-svg';
import { useNotify } from 'react-admin';

export const ProfilePhoto = (props) => {
  const { user } = props;
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef();
  const notify = useNotify();

  const Upload = (image) => {
    setLoading(true);
    addAvatar(image)
      .then((res) => {
        SaveData({ user: { ...user, image: res.image } });
        setLoading(false);
        setShow(false);
        notify('Profile updated successfully.');
      })
      .catch((msg) => {
        setLoading(false);
        notify(msg, 'warning');
      });
  };

  const handleSubmit = () => {
    fetch(Icons.defaultAvatar)
      .then((response) => response.blob())
      .then((blob) => {
        Upload(blob);
      });
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) Upload(file);
  };

  const handleUploadClick = () => {
    if (!loading && fileInputRef.current) fileInputRef.current.click();
  };

  const handleDeleteClick = () => {
    if (!loading) setShow(true);
  };

  return (
    <>
      <div className=" flex flex-col mx-auto items-center space-y-2">
        <div className="relative w-168 h-168 rounded-full border mb-8">
          <img
            src={user.image || Icons.defaultAvatar}
            alt="User Profile"
            className="rounded-full w-full h-full object-cover"
            onError={(e) => {
              e.target.src = Icons.defaultAvatar;
            }}
          />
          <button
            onClick={handleDeleteClick}
            disabled={loading}
            className={`shadow-none border-none bg-white w-10 h-10 flex items-center rounded-full justify-center cursor-pointer absolute bottom-0 right-0 border ${
              loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-50'
            }`}>
            <ReactSVG
              src={Icons.deleteIcon}
              className=""
              beforeInjection={(svg) => {
                svg.setAttribute('width', '20');
                svg.setAttribute('height', '20');
              }}
            />
          </button>
        </div>

        <IconButton
          onClick={handleUploadClick}
          icon={'pen'}
          text={'  Upload profile photo'}
          color={'#131617'}
          style={{ fontWeight: 400, height: 40 }}
          size={'mini'}
          loading={loading}
        />
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
        disabled={loading}
        style={{ display: 'none' }}
      />

      <Modal
        minWidth="unset"
        noX
        show={show}
        children={
          <span className="mt-6 text-center w-full md:min-w-xl">
            Are you sure you want to Remove your Profile Photo?
          </span>
        }
        submitText={'Yes, Remove'}
        icon={'deleteIcon'}
        title={'Remove Photo'}
        setShow={(value) => {
          setShow(value);
        }}
        submit={handleSubmit}
        loadingbutton={loading}
      />
    </>
  );
};
